// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"e30cc7cc","453":"b0493c97"}[chunkId] + ".chunk.js";
};